import { IconComponent } from '../icon.types';

export const ArrowDownBlueCircle: IconComponent = (props) => (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="18"
      width="48"
      height="48"
      rx="24"
      transform="rotate(22 18 0)"
      fill="#198AEC"
    />
    <g clipPath="url(#clip0_499_1812)">
      <path
        d="M41.9576 36.6428L29.0747 42.3418C28.3196 42.6623 27.4989 42.665 26.7571 42.3653C26.0154 42.0656 25.4268 41.4935 25.1211 40.7552L19.8165 27.6972L26.2419 30.2932L31.1117 18.2399L40.3836 21.9859L35.5137 34.0393L41.9576 36.6428Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_499_1812">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(15.6401 37.8738) rotate(-68)"
        />
      </clipPath>
    </defs>
  </svg>
);
